import {Component} from 'san';
import throttle from 'lodash.throttle';

import styles from './style/index.module.less';
import {inView} from '@/lib/utils/view';

export default class Video extends Component {
    static template = require('./index.html');
    initData() {
        return {
            styles,
            start: false,
            sendShowLog: false,
            supportVideo: true // video标签支持度98.61%
        };
    }
    attached() {
        const supportVideo = this.checkVideo();
        if (!supportVideo) {
            this.data.set('supportVideo', false);
        }
        this.bindScrollEvent();
        this.bindVideoEvent();
    }
    bindScrollEvent() {
        const vid = this.data.get('data.content.base.mediaId') || '';
        if (inView(this.el)) {
            this.storeDispatch('video:showLog', {vid});
            this.data.set('sendShowLog', true);
        } else {
            const sendShowLog = () => {
                if (inView(this.el) && !this.data.get('sendShowLog')) {
                    this.storeDispatch('video:showLog', {vid});
                    this.data.set('sendShowLog', true);
                    window.removeEventListener('scroll', scrollFn);
                }
            };
            const scrollFn = throttle(sendShowLog, 500);
            if (!this.data.get('sendShowLog')) {
                window.addEventListener('scroll', scrollFn);
            }
        }
    }
    bindVideoEvent() {
        const vid = this.data.get('data.content.base.mediaId') || '';
        this.ref('player').addEventListener('pause', () => {
            this.storeDispatch('video:pauseLog', {vid});
        });
        this.ref('player').addEventListener('play', () => {
            const start = this.data.get('start');
            if (!start) {
                this.storeDispatch('video:playLog', {vid});
            } else {
                this.storeDispatch('video:replayLog', {vid});
            }
        });
        this.ref('player').addEventListener('ended', () => {
            this.storeDispatch('video:endLog', {
                vid,
                duartion: this.data.get('data.content.base.long') || ''
            });
        });
    }
    onClick() {
        const start = this.data.get('start');
        if (!start) {
            this.data.set('start', true);
            this.ref('player').controls = 'controls';
            this.ref('player').play();
        }
    }
    checkVideo() {
        let vidTest = document.createElement('video');
        if (vidTest.canPlayType) {
            // 如果不能播放，canPlayType返回''
            let oggTest = !!vidTest.canPlayType('video/ogg');
            let mp4Test = !!vidTest.canPlayType('video/mp4');
            let webmTest = !!vidTest.canPlayType('video/webm');
            return oggTest || mp4Test || webmTest;
        }
        return false;
    }
};